import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Login from './module/admin/page/Login';
import AdminPrivateRoute from './module/admin/controller/AdminPrivateRoute';
import Candidate from './module/admin/page/Candidates';
import Questionnaire from './module/admin/page/Questionnaire';
import Test from './module/admin/page/Test';
import AddAndEditQuestion from './module/admin/page/AddAndEditQuestion';
import AddAndEditTest from './module/admin/page/AddAndEditTest';
import routes from './controller/Routes';
import Welcome from './module/test/page/Welcome';
import Detail from './module/test/page/Detail';
import TestPage from './module/test/page/TestPage';
import AdminPublicRoute from './module/admin/controller/AdminPublicRoute';
import Preview from './module/admin/page/Preview';
import CandidateLogin from './module/test/page/CandidateLogin';
import CandidatePrivateRoute from './module/test/controllor/CandidatePrivateRoute';
import NotValidURl from './module/test/page/NotValidURl';
import ThankyouPage from "./module/test/page/ThankyouPage";
import TimeOverPage from "./module/test/page/TimeOverPage";
import Invitation from "./module/admin/page/Invitation";
import Profile from "./module/admin/page/Profile";
import CandidateView from "./module/admin/page/CandidateView";
import TabOverLimit from "./module/test/page/TabOverLimit";
import User from './module/admin/page/User';
import AddAndEditUser from './module/admin/page/AddAndEditUser'
import OrganizationPrivateRoutes from './module/admin/controller/OrganizationPrivateRoutes';
import Organization from './module/admin/page/Organization';
import OpenTestPage from './module/test/page/OpenTestPage';
function App() {

  return (
    <div className='w-100' style={{ height: '100vh' }}>
      <BrowserRouter>
        <Routes>
          {/* [Admin route] */}
          <Route path='/' element={<Navigate to={routes.admin.login} />} />
          <Route
            path={routes.admin.login}
            element={
              <AdminPublicRoute>
                <Login />
              </AdminPublicRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.candidates}
            element={
              <AdminPrivateRoute>
                <Candidate />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.cadidateView}
            element={
              <AdminPrivateRoute>
                <CandidateView />
              </AdminPrivateRoute>
            }
          />
           {/* <Route
            path={routes.admin.dashboard.organization.self}
            element={
              <OrganizationPrivateRoutes>
                <Organization />
              </OrganizationPrivateRoutes>
            }
          /> */}
          <Route
            path={routes.admin.dashboard.user.self}
            element={
              <OrganizationPrivateRoutes>
                <User />
              </OrganizationPrivateRoutes>
            }
          />
          <Route
            path={routes.admin.dashboard.user.add}
            element={
              <OrganizationPrivateRoutes>
                <AddAndEditUser />
              </OrganizationPrivateRoutes>
            }
          />
          <Route
            path={routes.admin.dashboard.user.edit}
            element={
              <AdminPrivateRoute>
                <AddAndEditUser />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.questionnaire.self}
            element={
              <AdminPrivateRoute>
                <Questionnaire />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.test.self}
            element={
              <AdminPrivateRoute>
                <Test />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.questionnaire.add}
            element={
              <AdminPrivateRoute>
                <AddAndEditQuestion />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.questionnaire.edit}
            element={
              <AdminPrivateRoute>
                <AddAndEditQuestion />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.test.add}
            element={
              <AdminPrivateRoute>
                <AddAndEditTest />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.test.edit}
            element={
              <AdminPrivateRoute>
                <AddAndEditTest />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.invitation}
            element={
              <AdminPrivateRoute>
                <Invitation />
              </AdminPrivateRoute>
            }
          />
          <Route
            path={routes.admin.dashboard.profile}
            element={
              <AdminPrivateRoute>
                <Profile/>
              </AdminPrivateRoute>
            }
          />
          <Route path={routes.admin.preview} element={<Preview />} />
          {/* [Test Route] */}
          <Route path={routes.test.self} element={<CandidateLogin />} />
           <Route path={routes.test.open} element={<OpenTestPage />} />
          <Route
            path={routes.test.welcome}
            element={
              <CandidatePrivateRoute>
                <Welcome />
              </CandidatePrivateRoute>
            }
          />
          <Route
            path={routes.test.detail}
            element={
              <CandidatePrivateRoute>
                <Detail />
              </CandidatePrivateRoute>
            }
          />
          <Route
            path={routes.test.question}
            element={
              <CandidatePrivateRoute>
                <TestPage />
              </CandidatePrivateRoute>
            }
          />
          <Route
            path={routes.test.thankyou}
            element={
              <ThankyouPage />
            }
          />
          <Route
            path={routes.test.timeover}
            element={
              <TimeOverPage />
            }
          />
          <Route
            path={routes.test.taboverlimit}
            element={
              <TabOverLimit />
            }
          />
          <Route path={routes.test.validurl} element={<NotValidURl />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
